import { Badge } from '@recipes/ui';
import { Globe, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { RecipeOrigin } from '@recipes/contracts';

export interface OriginBadgeProps {
  origin: RecipeOrigin;
  sourceDomain?: string | null;
  className?: string;
}

/** "Imported from example.com" / "AI generated" marker (spec 6.3, 7.6). Nothing for user content. */
export function OriginBadge({ origin, sourceDomain, className }: OriginBadgeProps) {
  const { t } = useTranslation();
  if (origin === 'USER') return null;
  if (origin === 'AI_GENERATED')
    return (
      <Badge variant="info" className={className} data-testid="origin-badge">
        <Sparkles className="mr-1 size-3" aria-hidden />
        {t('recipes.origin.ai')}
      </Badge>
    );
  return (
    <Badge variant="muted" className={className} data-testid="origin-badge">
      <Globe className="mr-1 size-3" aria-hidden />
      {sourceDomain
        ? t('recipes.origin.importedFrom', { domain: sourceDomain })
        : t('recipes.origin.imported')}
    </Badge>
  );
}
